import React, { forwardRef } from 'react';
import * as RadixAccordion from '@radix-ui/react-accordion';

type AccordionContentProps = React.ComponentPropsWithoutRef<typeof RadixAccordion.Content>;

const AccordionContent = forwardRef<
  React.ElementRef<typeof RadixAccordion.Content>,
  AccordionContentProps
>(({ children, className, ...rest }, ref) => (
  <RadixAccordion.Content
    ref={ref}
    className="overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...rest}
  >
    <div className={className}>{children}</div>
  </RadixAccordion.Content>
));

const Content = AccordionContent;

export { type AccordionContentProps, AccordionContent, Content };
